// extracted by mini-css-extract-plugin
export default {"couponContainer":"FWzqamXcUXOjHeoxhLag","clickable":"lbAL6zCkn3883jNlaQ_w","couponInput":"pUqxJfGQbpnDERubwO4w","couponMessage":"hOPQMayIgsh1eCnC8hC4"};